import React from 'react';
import { useDispatch } from 'react-redux';
import { burgerMenuSlice } from './store';

export interface IBurgerMenuController {
  open: () => void;
  close: () => void;
}

export const useBurgerMenuController = (): IBurgerMenuController => {
  const dispatch = useDispatch();

  return React.useMemo(
    () => ({
      open: () => dispatch(burgerMenuSlice.actions.setVisible(true)),
      close: () => dispatch(burgerMenuSlice.actions.setVisible(false)),
    }),
    [dispatch],
  );
};
